<div class="col element-zoom m-0" [ngStyle]="contentStyle" *ngIf="isAddressFieldEnabled">
  <div
    class="widget-wrapper address"
    [ngClass]="isStepComplete ? 'step-complete' : isError ? 'error' : 'open'"
    [ngStyle]="borderStyle"
    style="min-height: 100%"
  >
    <form [formGroup]="addressForm">
      <div class="title-wrapper" *ngIf="widgetConfig.attributes['sub_heading']">
        <div class="title">
          <p [ngStyle]="colorTextAlignStyle">
            <span [innerHTML]="widgetConfig.attributes['sub_heading'] | safeHtml"> </span>
          </p>
        </div>
      </div>
      <div class="steps-count-wrapper">
        <span *ngIf="addressForm.valid && isAddressShowSuccessIcon" class="d-block">
          <img src="assets/images/check-circle.svg" alt="check-circle" class="img-fluid" />
        </span>
      </div>
      <div *ngIf="!isStepComplete && isError && isShowErrorMsg" class="error-msg">
        <img src="assets/images/exclamation-circle.svg" alt="check-circle" class="img-fluid" />
        <label>Address Restriction</label>
        <p>The Information entered can’t be validated</p>
      </div>
      <div class="form-wrapper">
        <ng-container *ngIf="searchAddressFieldAttribute as field">
          <label *ngIf="!pageConfig?.labelsAsPlaceholder" [ngStyle]="colorTextAlignStyle" class="d-block">{{
            field.label
          }}</label>
          <finxone-autocomplete-input
            inputIcon=""
            toggleIcon=""
            [id]="field.name"
            [filteredOptions]="filteredAddress"
            [loading]="isSearchingAddress"
            [optionLabelKey]="'address'"
            [optionValueKey]="'id'"
            [customOptionTemplate]="addressOptionTemplate"
            class="address-auto-complete w-100"
            (searchChanged)="searchAddresses($event)"
            (valueChanged)="onAddressOptionSelected($event)"
            (focus)="updateInputFieldCurrentStyles(true, field.name)"
            (blurEvent)="updateInputFieldCurrentStyles(false, field.name)"
          ></finxone-autocomplete-input>
          <ng-template #addressOptionTemplate let-option>{{ option?.address }}</ng-template>
          <div class="separator" [ngStyle]="colorTextAlignStyle">Or</div>
          <div class="d-flex">
            <p [ngStyle]="colorTextAlignStyle">Fill in manually</p>
            <span *ngIf="addressForm.invalid && isAddressShowErrorIcon" class="d-block ml-auto">
              <img
                (click)="showErrorMsg()"
                src="assets/images/exclamation-circle.svg"
                alt="check-circle"
                class="cursor img-fluid"
              />
            </span>
          </div>
        </ng-container>

        <div class="form-group" *ngFor="let field of widgetConfig.attributes['field_attributes']">
          <ng-container>
            <ng-container
              *ngIf="
                field.type !== 'country' &&
                field.type !== 'search_address' &&
                field.type !== 'city_postal_code' &&
                field.type !== 'dropdown'
              "
            >
              <ng-container
                *ngTemplateOutlet="addressInput; context: { field: field, formGroup: addressForm }"
              ></ng-container>
              <div
                class="text-error"
                *ngIf="addressForm.get(field.name)?.invalid && addressForm.get(field.name)?.touched"
              >
                <p>{{ field.label }} is a required field</p>
              </div>
            </ng-container>

            <ng-container *ngIf="field.type === 'country'">
              <ng-container
                *ngTemplateOutlet="countryInput; context: { field: field, formGroup: addressForm }"
              ></ng-container>
              <div
                class="text-error"
                *ngIf="addressForm.get(field.name)?.invalid && addressForm.get(field.name)?.touched"
              >
                <p>{{ field.label }} is a required field</p>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="form-group is-center" *ngIf="isAnyFieldRequired">
          <span class=" ">
            <img src="assets/images/exclamation-circle-gray.svg" alt="check-circle" class="img-fluid"
          /></span>
          <span class="validation-need-text"
            >Address needs Validation before proceeding to the next step.</span
          >
        </div>
        <div
          class="form-group m-0 is-hidden"
          style="position: fixed; bottom: 1em; left: 1em; width: calc(100% - 2em)"
        >
          <finx-button
            type="button"
            class="btn w-100 mt-2"
            labeltext="Confirm"
            (click)="onSubmit()"
          ></finx-button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- profile design -->

<div
  *ngIf="zone === 'profile' || zone === 'verification'"
  class="col profile-page"
  [ngClass]="zone === 'verification' ? 'pointer-events-none' : 'element-zoom'"
  [ngStyle]="combinedContentAndBorderStyles"
  style="height: 100%"
>
  <div class="form-wrapper collapsed" style="height: 100%">
    <form [formGroup]="addressForm" style="height: 100%; display: flex; align-items: center; width: 100%">
      <div style="width: 100%" class="main-form">
        <div class="form-group" *ngFor="let field of widgetConfig.attributes['field_attributes']">
          <ng-container
            *ngIf="
              field.type !== 'country' &&
              field.type !== 'search_address' &&
              field.type !== 'city_postal_code' &&
              field.type !== 'dropdown'
            "
          >
            <ng-container
              *ngTemplateOutlet="addressInput; context: { field: field, formGroup: addressForm }"
            ></ng-container>
            <div
              class="text-error"
              *ngIf="
                addressForm.get(field.name)?.touched && addressForm.get(field.name)?.invalid && !isWorkflow
              "
            >
              <p>{{ field.label }} is a required field</p>
            </div>
          </ng-container>
          <ng-container *ngIf="field.type === 'country'">
            <ng-container
              *ngTemplateOutlet="countryInput; context: { field: field, formGroup: addressForm }"
            ></ng-container>
            <div
              class="text-error"
              *ngIf="
                addressForm.get(field.name)?.touched && addressForm.get(field.name)?.invalid && !isWorkflow
              "
            >
              <p>{{ field.label }} is a required field</p>
            </div>
          </ng-container>
        </div>
        <div class="form-group is-center" *ngIf="isAnyFieldRequired">
          <span class=" ">
            <img src="assets/images/exclamation-circle-gray.svg" alt="check-circle" class="img-fluid"
          /></span>
          <span class="validation-need-text"
            >Address needs Validation before proceeding to the next step.</span
          >
        </div>
      </div>
    </form>
  </div>
</div>
<ng-template #addressInput let-field="field" let-formGroup="formGroup">
  <div [formGroup]="formGroup">
    <finxone-platform-label-input
      [label]="field.label"
      [labelAsPlaceholder]="field.type === 'city_postal_code' || pageConfig?.labelsAsPlaceholder"
      [type]="field.type"
      class="profile-input"
      formControlName="{{ field.name }}"
      [value]="addressForm.get(field.name)?.value ?? ''"
      [formGroup]="addressForm"
      [textColor]="colorStyle"
      [colorTextAlignStyle]="colorTextAlignStyle"
      [textInputFontStyle]="textInputFontStyle"
      (focusEvent)="updateInputFieldCurrentStyles($event, field.name)"
      [inputStyle]="addressInputFieldsStyles[field.name]"
    >
    </finxone-platform-label-input>
  </div>
</ng-template>
<ng-template #countryInput let-field="field" let-formGroup="formGroup">
  <div [formGroup]="formGroup">
    <label *ngIf="!pageConfig?.labelsAsPlaceholder" [ngStyle]="colorTextAlignStyle" class="d-block">{{
      field.label
    }}</label>
    <finxone-autocomplete-input
      inputIcon=""
      toggleIcon=""
      [id]="field.name"
      [filteredOptions]="filteredCountries"
      [selectedOption]="selectedCountry"
      [optionLabelKey]="'name'"
      [optionValueKey]="'code'"
      [customOptionTemplate]="countryOptionTemplate"
      class="autocomplete address-auto-complete w-100"
      (searchChanged)="filterCountries($event)"
      (valueChanged)="onAutoCompleteAddressChange($event)"
      (focus)="updateInputFieldCurrentStyles(true, field.name)"
      (blurEvent)="updateInputFieldCurrentStyles(false, field.name)"
    ></finxone-autocomplete-input>
    <ng-template #countryOptionTemplate let-option>{{ option?.name }}</ng-template>
  </div>
</ng-template>
